import { toProjectBankInput } from './projectBankInput';

/**
 * `Project.bank` field saved by the block project-bank-capital-assets. Must match
 * `ProjectBankCapitalAssetsInput` in the API schema.
 */
export const PROJECT_BANK_CAPITAL_ASSETS_INPUT_FIELDS = ['declaredAssets'];

/** `ProjectBankCapitalAssetsInput` from the block object. */
export const toProjectBankCapitalAssetsInput = (project) =>
  toProjectBankInput(project, PROJECT_BANK_CAPITAL_ASSETS_INPUT_FIELDS);
